export default __webpack_public_path__ + "static/media/basketball.3539d03f.webp";